import { useContext } from "react";
import { AuthContext } from "../contexts/Auth";

export default function useAuth() {
  const value = useContext(AuthContext);
  return value;
}
